/**
 * The How it works tab: the client tutorial for everyone; for whoever may
 * see the Admin guide (admins, or a role granted it) a switch on top and
 * the guide when `?part=admin` says so — anyone else falls back to the
 * tutorial, whatever the link says.
 * For Media Devoted | Created By Ciro Autiero
 */
import { ComponentProps, FC } from 'react';

import { TutorialTab } from '../tutorial/TutorialTab';
import { AdminGuide } from './AdminGuide';
import { PartSwitch } from './PartSwitch';
import { useCanSeeAdminGuide } from './use-engine-settings';

type Props = ComponentProps<typeof TutorialTab> & {
  /** ?part=admin */
  adminPart: boolean;
  onPart: (admin: boolean) => void;
};

export const HowItWorks: FC<Props> = ({ adminPart, onPart, ...tutorial }) => {
  const canSee = useCanSeeAdminGuide();
  if (!canSee) return <TutorialTab {...tutorial} />;
  return (
    <div className="flex flex-col gap-4">
      <PartSwitch admin={adminPart} onChange={onPart} />
      {adminPart ? <AdminGuide /> : <TutorialTab {...tutorial} />}
    </div>
  );
};
